<!--Stylen!!-->
@if (data?.length == 0) {
  <div class="cw-module-card empty-list">
    @if (loading) {
      <div class="cw-global-search-icon icon-spinner icon-spin"></div>
    }
    @if (!loading) {
      <p>{{ 'GLOBAL.HELP.LIST.NORESULTS' | translate }}</p>
    }
  </div>
}

<!-- Erste Ebene ausgeben -->
<ng-container *ngTemplateOutlet="recursiveList; context: {$implicit: data}"></ng-container>

<!-- Template für rekursive Ausgabe von Daten -->
<ng-template #recursiveList let-list>
  @for (item of list; track item) {
    <!-- Panel (Container) -->
    <mat-expansion-panel [disabled]="disablePanel(item.id)" (click)="$event.stopPropagation()">
      <!-- Header -->
      <mat-expansion-panel-header collapsedHeight="" expandedHeight="">
        <mat-panel-title (click)="$event.stopPropagation(); entrySelected(item.version_id)">
          <span class="cw-expansion-panel-title">{{ item.entry_name }} {{ item.level }}</span>
        </mat-panel-title>
        @if (allowDeleteHelpentry && item.children?.length === 0) {
          <div class="cw-toolbar">
            <span
              class="icon-delete cw-toolbar-icon"
            (click)="openDeleteDialog(item.id, item.entry_name)"></span>
          </div>
        }
      </mat-expansion-panel-header>
      <!-- rekursiver Aufruf von Template für Verschachtelung -->
      <ng-container *ngTemplateOutlet="recursiveList; context: {$implicit: item.children}"></ng-container>
    </mat-expansion-panel>
  }
</ng-template>
